import {createTheme} from '@mui/material/styles';

/**
 * 共通テーマ(Material-UI使用)
 */
const CommonTheme = createTheme({
  /*
  palette: {
    primary: {
      main: '#E60012', // '青系#4F89C6', 赤系'#FF0000',
      dark: '#990000', // '#001a37', '#990000',
      light: '#F5F5F5', // '#99C5F7',  '#ECD6C2'灰色#F5F5F5' 少し濃い灰色#C8C8CB 濃い灰色#7F878F
    },
    secondary: {
      main: '#F5F5F5', // 元々の赤系EA5433 青系4F89C6 中部電力の赤#E60012 と青#00a0e9
    },
  },
  */

  /* 
  breakpoints: {
    values: {
      lg: 1366,
    },
  },
  */

  // ロゴ色
  logo: {
    main: '#E70012',
  },

  menu: {
    width: 290,
    fontSize: '16pt',
  },
  chubuPalette: {
    primary: {
      main:  'primary.main',   // main: '#4F89C6',
      dark:  'primary.dark',   // dark: '#001a37',
      light: 'primary.light',  // light: '#99C5F7',
    },
    secondary: {
      main: 'secondary.main',  // main: '#E60012',
    },
  },
  mouse: {
    color: '#E0E0E0',
  },
});

export default CommonTheme;
